import { IReadNotification } from './../../../shared/types/IReadNotification';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificacoesService {

  private host = environment.api.host;
  private methods = environment.api.endpoints.methods.notificacoes;

  constructor(private http: HttpClient) { }

  public getListNotificacoes(pagina: string, qtdRegistros: string): Observable<any> {
    const url = this.host + this.methods.get.list;

    return this.http.get<any>(url, { params: { pagina, qtdRegistros } });
  }


  public getNotificacoesQuantidade(): Observable<any> {
    const url = this.host + this.methods.get.quantidade;

    return this.http.get<any>(url);
  }

  public readNotification(payload: IReadNotification): Observable<any> {
    const url = this.host + this.methods.post.readnotification;

    return this.http.post<any>(url, null, { params: { ...payload }, observe: 'response', responseType: 'text' as 'json' });
  }
}
